export enum PaymentSystem {
  AMERICAN_EXPRESS = 'american_express',
  DISCOVER = 'discover',
  MASTERCARD = 'master',
  VISA = 'visa',
}
